<template>
  <div>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains pt24">
          <div class="totals-box plr24">
            <div class="flex-row mb30">
              <div class="itemName">店员姓名</div>
              <div class="itemNum">{{ form.staffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">工号</div>
              <div class="itemNum">{{ form.staffNo }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">入职时间</div>
              <div class="itemNum">{{ formatDay(form.joinTime)}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">现在职门店</div>
              <div class="itemNum">{{ form.shopName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">现在职职位</div>
              <div class="itemNum">{{ form.positionName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">是否买股</div>
              <div class="itemNum">{{ form.stockFlagCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">晋升门店</div>
              <div class="itemNum">{{ form.elevateShopName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">晋升职位</div>
              <div class="itemNum">{{ form.elevatePositionName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">上任时间</div>
              <div class="itemNum">{{ form.auditStatus == 'pass' ? formatDate(form.assessmentStartTime) : formatDate(form.applyAppointmentTime) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">工作概况</div>
              <div class="itemNum break-all">{{ form.survey }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">晋升理由</div>
              <div class="itemNum break-all">{{ form.reason }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">征信报告截图</div>
              <div class="itemNum">

                <div v-for="(item,index) in form.creditImgList" :key="index" class="flex-row wraps">
                  <el-image 
                    style="width: 100px; height: 100px"
                    :src="item"
                    fit="fill"
                    :preview-src-list="form.creditImgList"
                  />
                </div>
              </div>
            </div>
          </div>
          <p class="order-title-boxs" v-if="form.flowAuditRecordList.length > 0"><span class="blueBlock"></span><i>审核流程</i></p>
          <div class="totals-box plr24">
            <div v-for="(item,index) in form.flowAuditRecordList" :key="index" class="mb30" style="border-bottom: 1px solid #dceaed;">
              <div class="flex-row mb30">
                <div class="itemName">{{item.flowNodeName}}</div>
                <div class="itemNum">{{ item.auditOpName }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">审核人</div>
                <div class="itemNum">{{ item.auditOpName }} <span v-if="item.auditStatus">（{{item.auditStatusCn}}）</span></div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">审核时间</div>
                <div class="itemNum">{{ formatDate(item.auditTime) }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">审核备注</div>
                <div class="itemNum">{{ item.auditRemark }}</div>
              </div>
            </div>
          </div>
          <p class="order-title-boxs" v-if="form.staffPositionElevateAssessmentList.length > 0"><span class="blueBlock"></span><i>考核流程</i></p>
          <div class="totals-box plr24">
            <div v-for="(item,index) in form.staffPositionElevateAssessmentList" :key="index" class="mb30" style="border-bottom: 1px solid #dceaed;">
              <div class="flex-row mb30">
                <div class="itemName">人力资源</div>
                <div class="itemNum">{{ item.auditOpName }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">考核人</div>
                <div class="itemNum">{{ item.staffName }} <span v-if="item.assessmentStatusCn">（{{item.assessmentStatusCn}}）</span></div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">考核时间</div>
                <div class="itemNum">{{ formatDate(item.time) }}</div>
              </div>
            </div>
          </div>
          <div class="drawer-footer pr24 pb10" v-if="form.updateFlag || form.cancelFlag">
            <el-button v-if="form.updateFlag" type="primary" @click="updateItem">修改</el-button>
            <el-button v-if="form.cancelFlag" type="danger" @click="cancelClick">撤销</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <add ref="addForm" @change="auditBack"></add>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import add from "./add.vue";
export default {
  mixins: [minxin],
  components: {
    drawer,
    add
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "晋升详情",
      form: {
        flowAuditRecordList: [],
        staffPositionElevateAssessmentList: []
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data())
        this.addEditShow = true;
        this.getDetails(org);
      });
    },
    getDetails (id) {
      this.auditList = [];
      this.$api.get(this.$url.staffPositionElevate.get + "?id=" + id).then(res => {
        this.form = res;
      })
    },
    updateItem () {
      this.$refs["addForm"].$emit("set", this.form);
    },
    cancelClick () {
      this.$confirm('确定要撤销吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        this.$api.get(this.$url.staffPositionElevate.cancel, {
          id: this.form.id
        })
        .then(res => {
          if (res) {
            this.$message.success("撤销成功");
            this.addEditShow = false;
            this.$emit("change")
          }
        });
      }).catch(() => {});
    },
    back () {
      this.addEditShow = false;
    },    auditBack () {
      this.getDetails(this.form.id);
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.itemNum-img {
  display: flex;
  .itemNumImgs {
    width: 80px;
    height: 80px;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  img {
    width: 100%;
    height: 100%; 
  }
}
.foot-msg {
  background: #FBFBFC;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  margin: 20px 24px 10px;
  color: #999;
  p {
    margin-bottom: 10px;
  }
  .infos {
    color: #111;
    margin-bottom: 10px;
  }
}
.padding-no {
  padding: 10px 20px 0;
}
</style>